//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "common-dialog",
  data() {
    return {
      DOM: "", //外包裹
      TITLE: "标题", //标题名称
      STYLE: '',
      CONTENT_HTML: "<p>内容</p>", //弹窗内容，可传html
      CONTENT: "内容", //弹窗内容，可传文本
      SHOW_CLOSE: false, //是否显示关闭按钮
      SHOW_CANCEL: false, //是否显示取消按钮
      DISA_SUBMIT: false, //确定按钮禁用
      SHOW_SUBMIT: true, //确定按钮禁用
      BTN_CANCEL: "取消", //取消按钮名称
      BTN_SUBMIT: "确定", //确定按钮名称
      BACK_CANCEL: null, //取消按钮回调
      BACK_SUBMIT: null //确定按钮回调
    };
  },
  methods: {
    //确定按钮事件
    submitDialogFn(e) {
      this.BACK_SUBMIT ? this.BACK_SUBMIT() : "";
      this.delAlert(e);
    },
    //取消按钮事件
    cancelDialogFn(e) {
      this.BACK_CANCEL ? this.BACK_CANCEL() : "";
      this.delAlert(e);
    },
    //删除弹窗
    delAlert(e) {
      // e.target.parentNode.parentNode.parentNode.parentNode.removeChild(e.target.parentNode.parentNode.parentNode);
      document.body.removeChild(this.DOM);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/common-dialog.vue